/**
 * Owner-doctor clinics (medopd-docs 148): a doctor who runs a clinic that has no clinic admin. They get the clinic
 * admin's screens in that clinic, except managing the team (for a clinic admin or staff they ask ClinVea, and a super
 * admin adds them) and the lab and pharmacy desks, which stay with the lab and pharmacy roles. Keep in step with
 * NavRouteService.hiddenFromOwner on the server.
 */
export const OWNER_TEAM_PATHS = ['/admin/staff', '/settings/doctors', '/admin/nav-settings'] as const;
const OWNER_HIDDEN_PREFIXES = ['/lab/', '/pharmacy/'] as const;

/** Screens the owner doctor does NOT get as "the clinic admin" (they keep whatever their doctor role gives them). */
export function isOwnerTeamPath(path: string): boolean {
  return OWNER_TEAM_PATHS.some((p) => path === p || path.startsWith(`${p}/`))
    || OWNER_HIDDEN_PREFIXES.some((p) => path.startsWith(p));
}
